module.exports = __webpack_public_path__ + "img/image_107.480aa60c.png";